export function initCheckoutCompany() {
    const config = window.webAudityCheckoutCompany || {};
    const fieldKeys = Array.isArray(config.fieldKeys) ? config.fieldKeys : [];

    function getWrapper() {
        return document.querySelector('.woocommerce-billing-fields__field-wrapper');
    }

    function getToggle() {
        return document.getElementById('web_audity_buy_as_company');
    }

    function getCompanyRows() {
        const rows = [];

        fieldKeys.forEach((key) => {
            const row = document.getElementById(`${key}_field`);
            if (row) {
                rows.push(row);
            }
        });

        document.querySelectorAll('.web-audity-company-field').forEach((row) => {
            if (!rows.includes(row)) {
                rows.push(row);
            }
        });

        return rows;
    }

    function clearCompanyInputs() {
        getCompanyRows().forEach((row) => {
            row.querySelectorAll("input:not([type='hidden']), textarea, select").forEach((el) => {
                if (el.type === 'checkbox' || el.type === 'radio') {
                    el.checked = false;
                    return;
                }
                el.value = '';
            });
        });
    }

    function setRequiredState(active) {
        getCompanyRows().forEach((row) => {
            row.querySelectorAll("input:not([type='hidden']), textarea, select").forEach((el) => {
                if (active) {
                    if (el.dataset.webAudityWasRequired === '1') {
                        el.setAttribute('required', 'required');
                    }
                    return;
                }

                if (el.hasAttribute('required')) {
                    el.dataset.webAudityWasRequired = '1';
                    el.removeAttribute('required');
                }
            });
        });
    }

    function hasCompanyValues() {
        return getCompanyRows().some((row) => Array.from(
            row.querySelectorAll("input:not([type='hidden']), textarea, select")
        ).some((el) => {
            if (el.type === 'checkbox' || el.type === 'radio') {
                return el.checked;
            }
            return String(el.value || '').trim() !== '';
        }));
    }

    function setActive(active) {
        const wrapper = getWrapper();
        if (wrapper) {
            wrapper.classList.toggle('web-audity-buy-as-company-active', active);
        }

        getCompanyRows().forEach((row) => {
            row.hidden = !active;
            row.style.display = active ? '' : 'none';
        });

        setRequiredState(active);
    }

    function bindToggle() {
        const toggle = getToggle();
        if (!toggle || toggle.dataset.webAudityBound === '1') {
            return;
        }

        toggle.dataset.webAudityBound = '1';

        toggle.addEventListener('change', () => {
            if (!toggle.checked) {
                clearCompanyInputs();
            }
            setActive(toggle.checked);
        });
    }

    function initIcInputs() {
        const maxLen = parseInt(config.icLength, 10) || 8;
        const fieldIds = Array.isArray(config.icFieldIds) ? config.icFieldIds : ['billing_ic', 'billing_company_number'];

        fieldIds.forEach((fieldId) => {
            const input = document.getElementById(fieldId);
            if (!input || input.dataset.webAudityIcBound === '1') {
                return;
            }

            input.dataset.webAudityIcBound = '1';
            input.setAttribute('inputmode', 'numeric');
            input.setAttribute('maxlength', String(maxLen));
            input.setAttribute('pattern', `[0-9]{${maxLen}}`);
            input.setAttribute('autocomplete', 'off');

            input.addEventListener('input', () => {
                input.value = String(input.value || '').replace(/\D/g, '').slice(0, maxLen);
            });

            input.addEventListener('paste', (event) => {
                event.preventDefault();
                const pasted = (event.clipboardData || window.clipboardData).getData('text') || '';
                input.value = pasted.replace(/\D/g, '').slice(0, maxLen);
                input.dispatchEvent(new Event('input', { bubbles: true }));
            });
        });
    }

    function initDicHelp() {
        const tooltipText = typeof config.dicTooltip === 'string' ? config.dicTooltip.trim() : '';
        if (!tooltipText) {
            return;
        }

        document.querySelectorAll('.web-audity-company-dic-field .woocommerce-input-wrapper').forEach((wrapper) => {
            if (wrapper.querySelector('.web-audity-dic-help-wrap')) {
                return;
            }

            const helpWrap = document.createElement('span');
            helpWrap.className = 'web-audity-dic-help-wrap';

            const helpBtn = document.createElement('button');
            helpBtn.type = 'button';
            helpBtn.className = 'web-audity-dic-help';
            helpBtn.setAttribute('aria-label', tooltipText);
            helpBtn.textContent = '?';

            const tooltip = document.createElement('span');
            tooltip.className = 'web-audity-dic-tooltip';
            tooltip.setAttribute('role', 'tooltip');
            tooltip.textContent = tooltipText;

            helpWrap.appendChild(helpBtn);
            helpWrap.appendChild(tooltip);
            wrapper.appendChild(helpWrap);

            const show = () => helpWrap.classList.add('is-open');
            const hide = () => helpWrap.classList.remove('is-open');

            helpBtn.addEventListener('mouseenter', show);
            helpBtn.addEventListener('mouseleave', hide);
            helpBtn.addEventListener('focus', show);
            helpBtn.addEventListener('blur', hide);
        });
    }

    const toggle = getToggle();
    if (!toggle) {
        return;
    }

    bindToggle();

    const shouldShow = toggle.checked || hasCompanyValues();
    if (shouldShow && !toggle.checked) {
        toggle.checked = true;
    }

    setActive(shouldShow);
    initIcInputs();
    initDicHelp();
}
